import {ChangeDetectionStrategy, Component, NgModule, ViewEncapsulation} from '@angular/core';

/**
 * @ngModule ActionFuncMagnifierPlusSvgModule
 */
@Component({
  selector: 'svg[ivyHermesActionFuncMagnifierPlus]',
  template: '<svg:g class="nc-icon-wrapper" transform="matrix(.8 0 0 .8 2.4 2.4)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"><svg:path data-color="color-2" fill="none" stroke-miterlimit="10" d="M10 7v6"></svg:path><svg:path data-color="color-2" fill="none" stroke-miterlimit="10" d="M13 10H7"></svg:path><svg:path fill="none" stroke-miterlimit="10" d="M22 22l-6.344-6.344"></svg:path><svg:circle cx="10" cy="10" r="8" fill="none" stroke-miterlimit="10"></svg:circle></svg:g>',

  styles: [
    ':host { fill: currentColor; stroke: currentColor; }',
      ],

  host: {
    'viewBox': '0 0 24 24',
  },

  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionFuncMagnifierPlusSvgComponent {
}

@NgModule({
  declarations: [
    ActionFuncMagnifierPlusSvgComponent,
  ],
  exports: [
    ActionFuncMagnifierPlusSvgComponent,
  ],
})
export class ActionFuncMagnifierPlusSvgModule {}
